import { useState } from 'react'

import { FilterGroup, FilterGroupsByPage,FilterPage } from 'context/filtersContext'
import { removeFilter } from 'utils/filters'

import { segmentTrack,TrackType } from '../utils/tracking'

const useFilterGroupsByPage = (initialValue: FilterGroupsByPage) => {
  const [filterGroupsByPage, setFilterGroupsByPage] = useState<FilterGroupsByPage>(initialValue)

  const updateNextGroups = (
    filterGroupsByPage: FilterGroupsByPage,
    nextGroups: FilterGroup[],
    page: FilterPage
  ) => {
    if (page !== FilterPage.ACCOUNT_DETAILS && page !== FilterPage.CONTACT_DETAILS) {
      return {
        ...filterGroupsByPage,
        [FilterPage.ACTIVITIES]: nextGroups.length ? nextGroups : [[]],
        [FilterPage.ACCOUNTS]: nextGroups.length ? nextGroups : [[]]
      }
    }

    return {
      ...filterGroupsByPage,
      [page]: nextGroups.length ? nextGroups : [[]]
    }
  }

  const handleClearFilterGroups = (page: FilterPage) => {
    segmentTrack(TrackType.CLEAR_FILTERS)
    setFilterGroupsByPage(filterGroupsByPage => {
      const nextGroups: FilterGroup[] = [[]]

      return updateNextGroups(filterGroupsByPage, nextGroups, page)
    })
  }

  const handleChangeFilterGroups = (filterGroups: FilterGroup[], page: FilterPage) => {
    setFilterGroupsByPage(filterGroupsByPage => {
      return updateNextGroups(filterGroupsByPage, filterGroups, page)
    })
  }

  const handleRemoveFilter = (page: FilterPage, groupIndex: number, filterIndex: number) => {
    segmentTrack(TrackType.REMOVE_FILTER)
    setFilterGroupsByPage(filterGroupsByPage => {
      const groups = filterGroupsByPage[page]
      const nextGroups = removeFilter(groups, groupIndex, filterIndex)
      return updateNextGroups(filterGroupsByPage, nextGroups, page)
    })
  }

  return {
    filterGroupsByPage,
    handleRemoveFilter,
    handleChangeFilterGroups,
    handleClearFilterGroups
  }
}

export default useFilterGroupsByPage
